<template>
  <v-card title="Incomplete Teams">
    <v-card-text>
      <v-data-table-server
        v-model="yearTeams.selected"
        :headers="yearTeams.headers"
        :items="yearTeams.data"
        :items-per-page="yearTeams.pageOptions.limit"
        item-key="id"
        :items-length="yearTeams.count"
        :search="yearTeams.pageOptions.q"
        @update:options="handleBranchYearTeamChange">
        <template v-slot:[`item.action`]="{ item }">
          <v-row justify="end">
            <v-col cols="auto">
              <!-- <router-link
                :to="{
                  name: 'AdminYearTeamDetailView',
                  params: { yearId: yearId, teamId: item.id },
                }">
                <v-icon icon="mdi-pencil">
                  <v-tooltip activator="parent" location="end">Edit Team</v-tooltip>
                </v-icon></router-link>-->
            </v-col>
          </v-row>
        </template>
        <template v-slot:top>
          <v-text-field
            v-model="yearTeams.pageOptions.q"
            class="ma-2"
            density="compact"
            placeholder="Search branch year..."
            hide-details></v-text-field>
          <v-btn color="primary" @click="exportToCSV(yearTeams.headers, yearTeams.data)"
            >Export to CSV</v-btn
          >
        </template>
      </v-data-table-server>
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import { getIncompleteTeamsForYear } from '@/controllers/admin';
import { IHeaderDTO, IPaginationDTO, ITeamDTO, PaginationDTO, TeamDTO } from '@/dtos';
import { ref } from 'vue';
import type { VDataTableServer } from 'vuetify/components';
import { exportToCSV } from '@/helpers';
import { useRoute } from 'vue-router';
const route = useRoute();

const yearId = Array.isArray(route.params.yearId)
  ? route.params.yearId[0]
  : (route.params.yearId ?? '');

const yearTeams = ref({
  pageOptions: new PaginationDTO() as IPaginationDTO,
  count: 0,
  data: [] as ITeamDTO[],
  loading: false,
  selected: [] as string[],
  headers: [
    { title: 'Team', key: 'name', align: 'start', sortable: true },
    {
      title: 'Branch',
      key: 'teamCriteria[0].branchYear.branch.name',
      align: 'start',
      sortable: true,
    },
    {
      title: 'Level',
      key: 'teamCriteria[0].teamLevel.team_level',
      align: 'start',
      sortable: true,
    },
    {
      title: 'Team Leader First Name',
      key: 'teamLeader.first_name',
      align: 'start',
      sortable: true,
    },
    { title: 'Team Leader Last Name', key: 'teamLeader.last_name', align: 'start', sortable: true },
    {
      title: 'Team Leader Email Address',
      key: 'teamLeader.email_address',
      align: 'start',
      sortable: true,
    },
    { title: '', key: 'action', align: 'end', sortable: false },
  ] as IHeaderDTO[],
});

const getYearTeams = async () => {
  try {
    const objs = await getIncompleteTeamsForYear(yearId, yearTeams.value.pageOptions);
    let teams = [];
    for (const team of objs.data) {
      teams.push(new TeamDTO(team));
    }
    yearTeams.value.data = teams;
    yearTeams.value.count = objs.count;
  } catch {}
};

const handleBranchYearTeamChange = (value: VDataTableServer) => {
  yearTeams.value.pageOptions.buildPagination(value);
  getYearTeams();
};
</script>
